(function () {
  const REVIEW_ACTIVITY_TOKEN = 'activity_M7UIqr84L48k4Yqh0Wyb5SzN';
  const REVIEW_COMPLETED_STORAGE_KEY = 'smileReviewActivityCompleted';
  const SUCCESS_SELECTOR = [
    '.bv-submission-thankyou',
    '[class*="bv-submission-thank"]',
    '[class*="bv-submission-success"]',
    '[class*="bv-thank"]',
  ].join(', ');
  const REVIEW_FORM_SELECTOR = 'form[action*="bazaarvoice.com"][action*="submitreview"]';
  const pendingForms = new WeakSet();
  let watchingForReviewConfirmation = false;
  let reviewActivitySent = false;

  function getReviewForm(target) {
    return target && target.closest ? target.closest(REVIEW_FORM_SELECTOR) : null;
  }

  function isBazaarvoiceElement(target) {
    return Boolean(
      target &&
        target.closest &&
        target.closest('[data-bv-show], [class*="bv-"], [id*="bv"], form[action*="bazaarvoice.com"]'),
    );
  }

  function hasReviewSuccessText() {
    return Array.from(document.querySelectorAll('[data-bv-show], [class*="bv-"], [id*="bv"]')).some(function (element) {
      const text = (element.textContent || '').toLowerCase().replace(/\s+/g, ' ');

      return text.includes('thank you') && (text.includes('review') || text.includes('submission'));
    });
  }

  function hasReviewSuccess() {
    return Boolean(document.querySelector(SUCCESS_SELECTOR)) || hasReviewSuccessText();
  }

  function waitForSmile(timeoutMs) {
    return new Promise(function (resolve, reject) {
      if (window.Smile) {
        resolve(window.Smile);
        return;
      }

      let complete = false;
      const timeout = window.setTimeout(function () {
        if (complete) return;
        complete = true;
        reject(new Error('Smile SDK never loaded'));
      }, timeoutMs);

      document.addEventListener(
        'smile-js-initialized',
        function () {
          if (complete) return;
          complete = true;
          window.clearTimeout(timeout);
          resolve(window.Smile);
        },
        { once: true },
      );
    });
  }

  function createActivity(smile) {
    if (smile && smile.activities && typeof smile.activities.create === 'function') {
      return smile.activities.create({ token: REVIEW_ACTIVITY_TOKEN });
    }

    return Promise.reject(new Error('Smile activity API is unavailable'));
  }

  function sendReviewActivity(form) {
    if (reviewActivitySent || form?.dataset.smileReviewActivitySent === 'true') return;
    reviewActivitySent = true;
    if (form) form.dataset.smileReviewActivitySent = 'true';

    waitForSmile(15000)
      .then(createActivity)
      .then(function () {
        window.localStorage.setItem(REVIEW_COMPLETED_STORAGE_KEY, 'true');
        window.dispatchEvent(new CustomEvent('smile-review-activity-completed'));
      })
      .catch(function (error) {
        reviewActivitySent = false;
        if (form) form.dataset.smileReviewActivitySent = 'false';
        console.error('Smile review activity failed', error);
      });
  }

  function watchForReviewConfirmation(form) {
    if (form) {
      if (pendingForms.has(form) || form.dataset.smileReviewActivitySent === 'true') return;
      pendingForms.add(form);
    } else if (watchingForReviewConfirmation) {
      return;
    }

    watchingForReviewConfirmation = true;
    let attempts = 0;
    const observer = new MutationObserver(function () {
      if (!hasReviewSuccess()) return;

      observer.disconnect();
      window.clearInterval(interval);
      watchingForReviewConfirmation = false;
      sendReviewActivity(form);
    });
    const interval = window.setInterval(function () {
      attempts += 1;

      if (hasReviewSuccess()) {
        observer.disconnect();
        window.clearInterval(interval);
        watchingForReviewConfirmation = false;
        sendReviewActivity(form);
        return;
      }

      if (attempts >= 90) {
        observer.disconnect();
        if (form) pendingForms.delete(form);
        watchingForReviewConfirmation = false;
        window.clearInterval(interval);
      }
    }, 500);

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('submit', function (event) {
    const form = getReviewForm(event.target);
    if (form || isBazaarvoiceElement(event.target)) {
      watchForReviewConfirmation(form);
    }
  });

  document.addEventListener('click', function (event) {
    const submitTarget = event.target.closest && event.target.closest('.bv-submit, [type="submit"]');
    if (!submitTarget) return;
    if (isBazaarvoiceElement(submitTarget)) {
      watchForReviewConfirmation(getReviewForm(submitTarget));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const submitTarget = event.target.closest && event.target.closest('.bv-submit, [type="submit"]');
    if (!submitTarget) return;
    if (isBazaarvoiceElement(submitTarget)) {
      watchForReviewConfirmation(getReviewForm(submitTarget));
    }
  });

  if (new URLSearchParams(window.location.search).get('review') === '1') {
    watchForReviewConfirmation();
  }
})();
